import React from "react";
import { browserHistory, Link } from "react-router";
import { formatFullName, formatNumber, getCurrencySymbol } from "../../../lib";
import moment from "moment";

export default function RewardRequestsTableRow(props) {
  const {
    eduProgramScheduleId,
    request,
    request: {
      campusName,
      createdOn,
      creditsToRedeem,
      currencyCode,
      creditValue,
      eduStudentEnrollmentID,
      rewardName,
      rewardType,
      shliachFirstName,
      shliachLastName,
      statusDisplay,
      status,
      studentFirstName,
      studentID,
      studentLastName,
      tripProgramScheduleID,
      tripStudentRegistrationID,
    },
    onApproveRejectRewardRequest,
    viewOnly,
  } = props;

  // trip applications are not managed via the regular approve/reject flow
  const canManageTripApplication =
    status === "Pending" && tripStudentRegistrationID;
  const canApproveRequest = status === "Pending" && !tripStudentRegistrationID;
  const canRejectRequest =
    (status === "Pending" || status === "Approved") &&
    !tripStudentRegistrationID;

  return (
    <Link
      className="courses-requests-table-row"
      to={{
        pathname: `/edu/${eduProgramScheduleId}/students/${studentID}`,
        query: { tab: eduStudentEnrollmentID, sub: "rewards" },
      }}
    >
      <p>{formatFullName(studentFirstName, studentLastName)}</p>
      <div>
        <p className="fw-700">{campusName}</p>
        <p>{formatFullName(shliachFirstName, shliachLastName)}</p>
      </div>
      <div>
        <p>{rewardName}</p>
        <p className="italic-text xs-text">{rewardType}</p>
      </div>
      <div>
        <p className="fw-700">{formatNumber(creditsToRedeem)}</p>
        <p>
          {getCurrencySymbol(currencyCode)}
          {formatNumber(creditValue * creditsToRedeem)}
        </p>
      </div>
      <p>{moment(createdOn).format("MM/DD/YYYY")}</p>
      <p>{statusDisplay}</p>
      <p>
        {!viewOnly && (
          <>
            {canManageTripApplication && (
              <span
                className="link-text"
                onClick={(e) => {
                  e.preventDefault();
                  browserHistory.push(
                    `/trips/${tripProgramScheduleID}/students/${tripStudentRegistrationID}`,
                  );
                }}
              >
                Manage trip application
              </span>
            )}
            {canApproveRequest && (
              <i
                className="material-icons ml-8 link-text-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  onApproveRejectRewardRequest(request, true);
                }}
                style={{ color: "#76E269" }}
              >
                thumb_up
              </i>
            )}
            {canRejectRequest && (
              <i
                className="material-icons ml-8 link-text-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  onApproveRejectRewardRequest(request, false);
                }}
                style={{ color: "#DC313F" }}
              >
                thumb_down
              </i>
            )}
          </>
        )}
      </p>
    </Link>
  );
}
